import type { FC } from 'react';

import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import { PartRegion } from '@/features/storefront/parts/PartRegion';
import type { ProductViewProps } from '@/features/storefront/layouts/product/types';

/** A tall photograph and a quiet column that keeps pace beside it. */
export const Product: FC<ProductViewProps> = () => (
  <StorefrontContainer className="grid gap-16 py-16 lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)]">
    <PartRegion name="gallery" />
    <PartRegion name="main" className="min-w-0 lg:sticky lg:top-24 lg:self-start" />
  </StorefrontContainer>
);
